type PageMeta = {
  title?: string;
  description?: string;
};

type TenantEnv = {
  siteName?: string;
  entityName?: string;
};

/**
 * Title and description for a CMS page, falling back to a tenant-branded default when the
 * editor has not set one.
 *
 * Extracted from `CmsPage` so it is testable without mounting the page and its four hooks.
 * These strings are what a crawler indexes and what a link preview shows, so "the default
 * still reads correctly when the tenant config has not loaded" is worth pinning down —
 * `tenantConfig` arrives asynchronously and is genuinely undefined on first render.
 */
export const buildCmsPageMeta = (meta: PageMeta | undefined, env: TenantEnv | undefined) => {
  const siteName = env?.siteName ?? '';
  const entityName = env?.entityName ?? '';

  return {
    metaTitle: meta?.title ?? `${siteName} Football News, Fixtures, Scores & Results`,
    metaDescription:
      meta?.description ?? `For all the latest ${entityName} news, visit the official website of the ${siteName}.`,
  };
};
